"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserWeeklyReportsDocument = exports.isUserWeeklyReports = exports.isUserWeeklyReportSingleDayData = exports.UserWeeklyReportsFirestoreCollection = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
exports.UserWeeklyReportsFirestoreCollection = "user-weekly-study-reports";
const UserWeeklyReportSingleDayDataSchema = zod_1.z.object({
    day: zod_1.z.string(),
    minutes: zod_1.z.number(),
});
exports.isUserWeeklyReportSingleDayData = type_validation_helpers_1.getTypeValidationFunction(UserWeeklyReportSingleDayDataSchema);
const UserWeeklyReportsSchema = zod_1.z.record(zod_1.z.array(UserWeeklyReportSingleDayDataSchema));
exports.isUserWeeklyReports = type_validation_helpers_1.getTypeValidationFunction(UserWeeklyReportsSchema);
const UserWeeklyReportsDocumentSchema = zod_1.z.object({
    declinedToSeeReports: zod_1.z.array(zod_1.z.string()).optional(),
    // reports is an object containing weekly reports data, with date as key and an array of each day data in that week
    // each key is a date in YYYY-MM-DD format
    // e.g: reports: {"2020-02-08": [{day: "S", minutes 5}], "2020-09-24": [{day: "M", minutes: 3}, {day: "T", minutes: 7}]}
    reports: UserWeeklyReportsSchema.optional(),
    seenReports: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.isUserWeeklyReportsDocument = type_validation_helpers_1.getTypeValidationFunction(UserWeeklyReportsDocumentSchema);
//# sourceMappingURL=weekly_study_reports_types.js.map